import { ref } from 'vue'

import { defineStore } from 'pinia'

import type * as aggr from '@/api-generator/aggr/index'

export const useUserMgmtProfileStore = defineStore('userMgmtProfile', () => {
  const $reset = () => {
    summary.value = undefined
  }

  const summary = ref<aggr.UserProfileQuerySummaryRs>()

  const setSummary = (data: aggr.UserProfileQuerySummaryRs) => {
    summary.value = data
  }

  return { $reset, summary, setSummary }
})
